// Dependencies
import React from 'react';

import classnames from 'classnames';

// Local components.
import Panel from './panel/panel';

// CSS
require('./two-panel-container.less');

interface TwoPanelContainerProps {
  split?: string;
  className?: string;
  orientation?: string;
  primaryPanelProps: Record<string, any>;
  secondaryPanelProps: Record<string, any>;
}

export const TwoPanelContainer: React.FC<TwoPanelContainerProps> = ({
  split = '50%',
  className = '',
  orientation = 'horizontal',
  primaryPanelProps = {},
  secondaryPanelProps = {},
}) => {
  const primaryPanelStyle = { width: '' };
  const secondaryPanelStyle = {};

  if (orientation === 'horizontal') {
    primaryPanelStyle.width = split;
  }

  return (
    <div className={classnames('two-panel-container', orientation, className)}>
      <Panel style={primaryPanelStyle} {...primaryPanelProps} />
      <Panel style={secondaryPanelStyle} {...secondaryPanelProps} />
    </div>
  );
};

export default TwoPanelContainer;
